import {action, observable} from 'mobx';

class BannerStore {
    @observable claim = "claim.home";

    @action setClaim(claim) {
        this.claim = claim;
    }
}
export default BannerStore;